<template>
  <div class="container-fluid">
    <first-start v-if="doFirstStart" />
    <div v-if="staticItems.items.length == 0" class="row"><div class="col text-center"><i class="far fa-grin-stars fa-spin"></i></div></div>
    <Navbar-FeedCategories :categories="staticItems.items" routeName="static" />
    <Content-Static :feeds="staticItems" routeName="static" />
    <navbar-dynamic-bars :feeds="staticItems" routeName="staticWithPage" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { Plugins } from "@capacitor/core";
import "tuer-plugin";

const { TuerPlugin } = Plugins;

// @ is an alias to /src
import NavbarFeedCategories from "@/components/Navbars/Navbar.FeedCategories.vue";
import NavbarDynamicBars from "@/components/Navbars/NavbarDynamicBars.vue";
import FirstStart from "@/components/FirstStart.vue";
import ContentStatic from "@/components/ContentStatic.vue";

export default {
  name: "home",
  components: {
    NavbarFeedCategories,
    NavbarDynamicBars,
    ContentStatic,
    FirstStart
  },
  computed: {
    doFirstStart: function() {
      return !window.localStorage.getItem("FirstStart");
    },
    staticItems: function() {
      return this.$store.state.StaticFeeds;
    }
  },
  methods: {
    ...mapActions(["loadStaticFeeds"]),
    onStartAction: function() {

      TuerPlugin.echo({ mode: "static", value: "https://indie42.de/dist/static_feeds.php" })
        .then(ret => {
          //console.log(ret.value);
          //this.loadStaticFeeds(JSON.parse(ret.value));
          this.loadStaticFeeds(ret.value);
        });
    }
  },
  created() {
    this.onStartAction();
  }
};
</script>
